import React, { useContext } from 'react';
import { View } from 'react-native';
import { Components, Theme } from '@oneamerica/dxp-ui-components';
import BreakpointConstants from '../../../../../constants/BreakpointConstants';
import responsiveStyle from './style';
import { analyticsTags } from '../../../../../utils/Analytics/AnalyticsTags';
import { trackCustomEvent } from '../../../../../utils/Analytics/AdobeAnalyticsUtils';

const LegalDisclaimerModal = ({
  isVisible,

  onAgree,
  onClose,
  isHomePage = false,
}: {
  isVisible: boolean;

  onAgree: CallableFunction;
  onClose?: CallableFunction;
  isHomePage?: boolean;
}) => {
  const { width } = useContext(Theme.ResponsiveContext);
  const style = responsiveStyle();

  // Responsive modal sizing and styles
  let modalStyle;
  if (BreakpointConstants.isLG(width)) {
    modalStyle = style.lgModalSize;
  } else if (BreakpointConstants.isMD(width)) {
    modalStyle = style.mdModalSize;
  } else {
    modalStyle = style.smModalSize;
  }

  const handleClose = () => {
    trackCustomEvent(
      isHomePage
        ? analyticsTags.CaptureLegalDisclaimerCloseHomePageTags
        : analyticsTags.CaptureLegalDisclaimerClosePolicyDetailsTags,
    );
    onClose?.();
  };

  const handleCancel = () => {
    trackCustomEvent(
      isHomePage
        ? analyticsTags.CaptureLegalDisclaimerCancelHomePageTags
        : analyticsTags.CaptureLegalDisclaimerCancelPolicyDetailsTags,
    );
    onClose?.();
  };

  const handleAgree = () => {
    trackCustomEvent(
      isHomePage
        ? analyticsTags.CaptureLegalDisclaimerAgreeHomePageTags
        : analyticsTags.CaptureLegalDisclaimerAgreePolicyDetailsTags,
    );

    onAgree?.();
  };

  return (
    <Components.DialogModal
      style={modalStyle}
      width="auto"
      padding={20}
      visible={isVisible}
      onClose={handleClose}
    >
      <View style={style.placeholderWrapper}>
        <Components.Text style={style.modalBody}>
          By clicking this third-party external link, you will be redirected to
          PayerExpress, a payment platform operated by PNC Bank. This platform
          is not controlled, reviewed, endorsed, or maintained by OneAmerica
          Financial®, which assumes no responsibility for its content,
          policies, or practices.
        </Components.Text>

        <View style={style.buttonsContainer}>
          <Components.Button
            theme="secondary"
            style={style.cancelbutton}
            onPress={handleCancel}
            testID="cancelButton"
          >
            Cancel
          </Components.Button>
          <Components.Button
            theme="primary"
            style={style.button}
            onPress={handleAgree}
            testID="agreeButton"
          >
            I agree
          </Components.Button>
        </View>
      </View>
    </Components.DialogModal>
  );
};

export default LegalDisclaimerModal;
